import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

import DropdownItemModel from "@/pages/_uc/dropdown-multiselect/dropdownModel";
import moment from "moment";
import {
  TirPmButton,
  TirPmButtonSizeEnum,
  TirPmStatus,
  TirPmTableTd,
} from "tir-components";
import {
  PencilSquareIcon,
  AdjustmentsVerticalIcon,
  TrashIcon,
  PlusIcon,
  PaperClipIcon,
  WindowIcon,
  ArrowUturnLeftIcon,
  ArrowUturnRightIcon,
} from "tir-style-system/icons/outline/";

import {
  ref,
  computed,
  onMounted,
  watch,
  PropType,
} from "vue";

import TirLink from "@/pages/_uc/vue3-tir-link/tir-link.vue";

import { PaintIcon } from "tir-style-system/icons/solid";
import UserDate from "@/pages/job/components/user-date.vue";
import { ScheduleStatus } from "@/pages/_uc/schedule-status";

// Определение пропсов компонента

export default /*#__PURE__*/_defineComponent({
  __name: 'dashboard-row',
  props: {
  data: {
    type: Object as PropType<any>,
  },
},
  emits: ["clickAction", "clickDetail", "clickRemove"],
  setup(__props, { emit: emits }) {

const props = __props;

// Импорты из Vue 3 Composition API


// Определение эмиттеров событий компонента


function onClickDetail() {
  emits("clickDetail", props.data);
}

return (_ctx: any,_cache: any) => {
  return (__props.data)
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        _createVNode(_unref(TirPmTableTd), {
          class: "pointer",
          style: {"overflow":"hidden","min-width":"100px"},
          onClick: onClickDetail,
          "is-left-border": false
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(moment)(__props.data.StartDate).format("DD-MM-YYYY HH:mm:ss.SSS")), 1)
          ]),
          _: 1
        }),
        _createVNode(_unref(TirPmTableTd), {
          class: "pointer",
          onClick: onClickDetail
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(__props.data.JobName), 1)
          ]),
          _: 1
        }),
        _createVNode(_unref(TirPmTableTd), {
          class: "pointer",
          onClick: onClickDetail
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(ScheduleStatus), {
              typeName: __props.data.Status,
              isFullSize: ""
            }, null, 8, ["typeName"])
          ]),
          _: 1
        }),
        _createVNode(_unref(TirPmTableTd), null, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(__props.data.Massage), 1)
          ]),
          _: 1
        })
      ], 64))
    : _createCommentVNode("", true)
}
}

})